import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { RestaurantProvider } from './providers/RestaurantContext';
import AppRoutes from './routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from './shared/ErrorBoundary';

const App: React.FC = () => {
  // 🧪 Diagnostic: Check if environment variables are loading
  console.log('NODE_ENV =', process.env.NODE_ENV);
  console.log('REACT_APP_BASE_URL =', process.env.REACT_APP_BASE_URL);
  
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  if (!isInitialized) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Initializing...</p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <Router>
        <RestaurantProvider>
          <AppRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </RestaurantProvider>
      </Router>
    </ErrorBoundary>
  );
};

export default App;

